<template>
  <div class="page-not-found">
    <div class="page-not-found-wrapper">
      <strong class="page-not-found-heading">Sidan kunde inte hittas</strong>
      <p>Sidan du försökte nå hittades inte.</p>
      <router-link to="/" class="page-not-found-link"><i class="fas fa-home"></i>Till startsidan</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  mounted () {
    document.title = 'Gluo - Sidan kunde inte hittas'

    let meta = document.createElement('meta')
    meta.setAttribute('name', 'robots')
    document.head.appendChild(meta)
    meta.setAttribute('content', 'noindex')
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.page-not-found {
  display: flex;
  justify-content: center;
}

.page-not-found-wrapper {
  width: 320px;
  margin-top: 24px;
  margin-bottom: 64px;
  padding-left: 16px;
  padding-right: 16px;
  text-align: center;

  @include breakpoint-up($md) {
    margin-top: 64px;
    padding-left: 0;
    padding-right: 0;
  }
}

.page-not-found-heading {
  color: map-get($colors, gray-medium);
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 32px;
  display: block;
}

.page-not-found-link {
  margin-top: 32px;
  display: inline-block;
}

.page-not-found-link .fas {
  margin-right: 8px;
}
</style>
